import { useApolloClient, useMutation } from '@apollo/client';
import { useCallback, useState } from 'react';
import {
  ADD_ORG_USER,
  GET_ORG_USER_MEMBERSHIP_INCLUDING_ARCHIVED,
  UPDATE_ORG_USER,
} from 'src/graphql/organizations/queries';

export const useAddOrUnarchiveOrgUser = () => {
  const client = useApolloClient();
  const [addOrgUser] = useMutation(ADD_ORG_USER);
  const [updateOrgUser] = useMutation(UPDATE_ORG_USER);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const run = useCallback(
    async ({ variables }) => {
      const { organization_id, user_id, role_id } = variables.data;
      setLoading(true);
      setError(null);
      try {
        const existing = await client.query({
          query: GET_ORG_USER_MEMBERSHIP_INCLUDING_ARCHIVED,
          variables: { org_id: organization_id, user_id },
          fetchPolicy: 'network-only',
        });

        const rows = existing.data?.rows ?? [];
        const archived = rows.find((r) => r.flg_inactive === 'Y');

        if (archived) {
          await updateOrgUser({
            variables: {
              org_id: organization_id,
              user_id,
              data: { flg_inactive: 'N', role_id },
            },
          });
          return {
            data: {
              row: {
                user_organization_id: archived.user_organization_id,
                organization_id,
                user_id,
                user_organizations_role: null,
              },
            },
          };
        }

        return await addOrgUser({
          variables: { data: { organization_id, user_id, role_id } },
        });
      } catch (e) {
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [client, addOrgUser, updateOrgUser]
  );

  return [run, { loading, error }];
};
